<template>
  <div class="dash-card upcoming-events-widget">
    <div class="dash-card-header">
      <h3 class="dash-card-title">
        <span
          class="dash-card-title-icon"
          style="background: #e6f7ff; color: #1890ff"
        >
          <a-icon type="calendar" />
        </span>
        {{ $t("accueil.dashboard.upcomingEvents") }}
      </h3>
      <span class="dash-card-action" @click="seeAll">
        {{ $t("accueil.dashboard.seeAllEvents") }}
        <a-icon type="right" />
      </span>
    </div>

    <div class="dash-card-body">
      <div v-if="events.length" class="events-list dash-scroll">
        <div v-for="event in events" :key="event._id" class="event-item">
          <div
            class="event-date"
            :style="{ borderColor: event.color || '#1890ff' }"
          >
            <span class="event-day">{{ formatDay(event.start) }}</span>
            <span class="event-month">{{ formatMonth(event.start) }}</span>
          </div>
          <div class="event-content">
            <div class="event-title">{{ event.title }}</div>
            <div class="event-meta">
              <span class="event-time">
                <a-icon type="clock-circle" />
                {{ formatTime(event.start) }} - {{ formatTime(event.end) }}
              </span>
              <span class="dash-badge" :style="badgeStyle(event.color)">
                {{ typeLabel(event.type) }}
              </span>
            </div>
          </div>
          <div class="event-duration">
            {{ formatDuration(event.start, event.end) }}
          </div>
        </div>
      </div>
      <div v-else class="dash-empty-state events-empty">
        <div class="dash-empty-icon">
          <a-icon type="calendar" />
        </div>
        <div>{{ $t("accueil.dashboard.noUpcomingEvents") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import "moment-duration-format";

export default {
  name: "UpcomingEventsWidget",
  props: {
    events: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    formatDay(date) {
      return moment(date).format("DD");
    },
    formatMonth(date) {
      return moment(date).format("MMM");
    },
    formatTime(date) {
      return moment(date).format("HH:mm");
    },
    formatDuration(start, end) {
      return moment
        .duration(moment(end).diff(moment(start)))
        .format({
          userLocale: moment.locale(),
        });
    },
    typeLabel(type) {
      if (!type) return "";
      const key = `calender.${type}`;
      const label = this.$t(key);
      return label === key ? type : label;
    },
    badgeStyle(color) {
      const c = color || "#1890ff";
      return { backgroundColor: `${c}22`, color: c };
    },
    seeAll() {
      if (this.$route.path !== "/calender") {
        this.$router.push({ path: "/calender" });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.upcoming-events-widget {
  display: flex;
  flex-direction: column;
}

.dash-card-body {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.events-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
  max-height: 320px;
  overflow-y: auto;
}

.events-empty {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: 160px;
}

.event-item {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 10px;
  border-radius: 12px;
  transition: background 0.18s ease;

  &:hover {
    background: #fafafa;
  }
}

.event-date {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: 12px;
  border: 2px solid #1890ff;
  flex-shrink: 0;

  .event-day {
    font-size: 1.1rem;
    font-weight: 800;
    color: #1a1a1a;
    line-height: 1;
  }

  .event-month {
    font-size: 0.65rem;
    font-weight: 700;
    text-transform: uppercase;
    color: #8c8c8c;
  }
}

.event-content {
  flex: 1;
  min-width: 0;
}

.event-title {
  font-size: 0.85rem;
  font-weight: 600;
  color: #262626;
  margin-bottom: 4px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.event-meta {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}

.event-time {
  font-size: 0.72rem;
  color: #8c8c8c;
  display: flex;
  align-items: center;
  gap: 4px;
}

.event-duration {
  font-size: 0.75rem;
  font-weight: 500;
  color: #bfbfbf;
  flex-shrink: 0;
  white-space: nowrap;
  text-align: right;
}

[data-kit-theme="dark"] {
  .event-item:hover {
    background: #141322;
  }

  .event-date .event-day {
    color: #aeaee0;
  }

  .event-title {
    color: #aeaee0;
  }

  .event-duration {
    color: #5c5c7a;
  }
}
</style>
